import { TypeAnimation } from "react-type-animation";
import { Link as ScrollLink } from 'react-scroll';
import useStartAnimation from "../hook/useStartAnimation";
import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export default function Header() {
  const animated = useStartAnimation();
  const { content, lang } = useContext(LanguageContext);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: "#091c29" }}
    >
      <div className="w-10/12 mx-auto flex flex-col md:flex-row-reverse items-center justify-between">
        <div className="w-full md:w-1/5 opacity-75 flex justify-center md:justify-start md:-ml-4">
                <img
                  src="/assets/my-image2.png"
                  alt="profile"
                  loading="lazy"
                  className="
                  md:w-92 lg:w-92
                    transition duration-300
                    blur-sm hover:blur-0
                  "
                />
        </div>

        <div className="md:ml-4 md:mr-4 text-white font-dosis text-center md:text-right">
          <h2
            className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-1000 ease-in-out text-3xl md:text-5xl font-bold`}
          >
            {content.header.text[0]}
            <br />
            {content.header.text[1]}
          </h2>

          <h1
            className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-1000 ease-in-out
              font-bold
              text-sm md:text-lg lg:text-xl xl:text-2xl
              text-gray-400`}
          >
            {content.header.text[2]}{' '}
             <TypeAnimation
              key={lang} // 🔥 THIS IS THE FIX
              sequence={content.header.typical}
              speed={50}
              repeat={Infinity}
              wrapper="span"
              className="inline-block"
            />
          </h1>

          <ScrollLink to="technology" smooth>
            <button
              className="
                animate-float
                bg-indigo-500 mt-10 px-10 py-3
                text-xl border text-white font-bold rounded-lg
              "
            >
              {content.header.btnText}
            </button>
          </ScrollLink>
        </div>
      </div>
    </div>
  );
}
